import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import SnackbarUtils from 'utils/SnackbarUtils';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CONTRATO_STATUS_EM_EDICAO } from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';

class GenericDados extends GenericContent {
  getSubmitMessageSuccess = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.successAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.successDistratoSalvar;
        default:
          return this.props.languageValues.successContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.successAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.successDistratoPreCadastro;
      default:
        return this.props.languageValues.successContratoPreCadastro;
    }
  };

  getSubmitMessageError = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.erroAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.erroDistratoSalvar;
        default:
          return this.props.languageValues.erroContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroDistratoPreCadastro;
      default:
        return this.props.languageValues.erroContratoPreCadastro;
    }
  };

  toSubmit = (index, data, callbackStart, callbackSuccess, callbackError) => {
    if (index === 0 || index === 1) {
      this.toNextContent();
      return;
    }
    if (!this.hasPermissions()) {
      return;
    }
    if (typeof callbackStart === 'function') {
      callbackStart();
    }

    if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_ADITIVO
    ) {
      this.props.cadastroAditivoEntePrivado(
        {
          idContrato: data.idContrato,
          atividades: data.atividades,
          dataFim:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataFim, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          dataInicio:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataInicio, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          planosTrabalho: data.planoTrabalho,
          totalMeses: data.totalMeses,
          escolaCompromissoCheck: data.escolaCompromissoCheck,
          emailCoop: data.emailCoop,
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.getSubmitMessageSuccess(data),
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText || this.getSubmitMessageError(data),
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    } else if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
    ) {
      this.props.cadastroDistratoEntePrivado(
        {
          idContrato: data.idContrato,
          dataDistrato: moment(data.dataDistrato, 'DD MM YYYY').format(
            'DD-MM-YYYY'
          ),
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.getSubmitMessageSuccess(data),
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText || this.getSubmitMessageError(data),
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    } else {
      this.props.cadastroContratoEntePrivado(
        {
          atividades: data.atividades,
          codCoop: data.codCoop,
          cpfProfessor: data.cpfProfessor,
          dataFim:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataFim, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          dataInicio:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataInicio, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          emailCoop: data.emailCoop,
          idEscola: data.idEscola,
          nomEscola: data.nomEscola,
          planosTrabalho: data.planoTrabalho,
          totalMeses: data.totalMeses,
          escolaCompromissoCheck: data.escolaCompromissoCheck,
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.getSubmitMessageSuccess(data),
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText || this.getSubmitMessageError(data),
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    }
  };

  toEdit = (
    idContrato,
    index,
    data,
    callbackStart,
    callbackSuccess,
    callbackError
  ) => {
    if (index === 0 || index === 1) {
      this.toNextContent();
      return;
    }
    if (!this.hasPermissions()) {
      return;
    }
    if (typeof callbackStart === 'function') {
      callbackStart();
    }

    if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_ADITIVO
    ) {
      this.props.editarAditivoEntePrivado(
        this.props.contratosEntePrivado.contratoEditing.idAditivo,
        {
          idContrato,
          atividades: data.atividades,
          dataFim:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataFim, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          dataInicio:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataInicio, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          planosTrabalho: data.planoTrabalho,
          totalMeses: data.totalMeses,
          escolaCompromissoCheck: data.escolaCompromissoCheck,
          emailCoop: data.emailCoop,
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.sucessEditAditivoEntePrivado,
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorEditAditivoEntePrivado,
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    } else if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
    ) {
      this.props.editarDistratoEntePrivado(
        {
          dataDistrato: moment(data.dataDistrato, 'DD MM YYYY').format(
            'DD-MM-YYYY'
          ),
          idDistrato:
            this.props.contratosEntePrivado.contratoEditing.idDistrato,
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.sucessEditEntePrivado,
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorEditEntePrivado,
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    } else {
      this.props.editarEntePrivado(
        idContrato,
        {
          atividades: data.atividades,
          codCoop: data.codCoop,
          cpfProfessor: data.cpfProfessor,
          dataFim:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataFim, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          dataInicio:
            data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
              ? moment(data.dataInicio, 'DD MM YYYY').format('DD/MM/YYYY')
              : '',
          emailCoop: data.emailCoop,
          idEscola: data.idEscola,
          nomEscola: data.nomEscola,
          planosTrabalho: data.planoTrabalho,
          totalMeses: data.totalMeses,
          escolaCompromissoCheck: data.escolaCompromissoCheck,
        },
        (resp) => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.sucessEditEntePrivado,
            options: {
              variant: 'success',
            },
          });
          if (typeof callbackError === 'function') {
            callbackSuccess(resp);
          }
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorEditEntePrivado,
            options: {
              variant: 'error',
            },
          });
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      );
    }
  };

  editing = () => {
    return this.props.editing || false;
  };

  disabledWhenAditivo = () => {
    if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_ADITIVO
    ) {
      return true;
    }
    return false;
  };

  disabledWhenDistrato = () => {
    if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
    ) {
      return true;
    }
    return false;
  };

  hasPermissions = () => {
    if (!this.props.contratosEntePrivado.contratoEditing.ativo) {
      return false;
    }
    if (this.editing()) {
      return (
        this.props.contratosEntePrivado.contratoEditing.flgStatus ===
          CONTRATO_STATUS_EM_EDICAO &&
        this.props.auth.userPermissions.contratos.entePrivado.edit
      );
    }
    return (
      this.props.contratosEntePrivado.contratoEditing.flgStatus <=
        CONTRATO_STATUS_EM_EDICAO &&
      this.props.auth.userPermissions.contratos.entePrivado.register
    );
  };

  setValue = (event, callback) => {
    let newEvent = { ...event };
    if (newEvent.target.name === 'totalMeses') {
      newEvent.target.value = !newEvent.target.value
        ? 0
        : Number(newEvent.target.value).toString();
    }
    const lastValue =
      this.props.contratosEntePrivado.contratoEditing[newEvent.target.name];
    if (newEvent.target.value !== lastValue) {
      this.setState(
        {
          ...this.state,
          [newEvent.target.name + 'Changed']: true,
        },
        () => {
          if (typeof callback === 'function') {
            callback();
          }
        }
      );
      this.props
        .changeContratoEntePrivadoEditingValue(
          newEvent.target.name,
          newEvent.target.value
        )
        .then(() => {
          const method = this[newEvent.target.name + 'OnChanged'];
          if (typeof method === 'function') {
            method(newEvent.target.value, lastValue);
          }
        });
    }
  };

  render() {
    return <></>;
  }
}

GenericDados.propTypes = {
  editing: PropTypes.bool,
  loading: PropTypes.bool,
};

export default GenericDados;
